import React, { useEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';
import { useTranslation } from 'react-i18next';

const Conact = () => {
	gsap.registerPlugin(ScrollTrigger);
	const refContact = useRef(null);
	const { t } = useTranslation('translation', {
		keyPrefix: 'contact',
	});

	useEffect(() => {
		let ctx = gsap.fromTo(
			refContact.current,
			{
				opacity: 0,
			},
			{
				opacity: 1,
				duration: 2,
				scrollTrigger: {
					trigger: refContact.current,
					start: 'top 50%',
					end: 'top 60%',
					// markers: true,
				},
			}
		);
		return () => ctx.revert();
	}, []);

	return (
		<section
			name='contact'
			className='w-full h-screen bg-gradient-to-b from-black to-gray-800 p-4 text-white'
		>
			<div
				ref={refContact}
				className='flex flex-col justify-center p-4 max-w-screen-lg mx-auto h-full'
			>
				<div className='pb-8'>
					<p className='text-4xl font-bold inline border-b-4 border-gray-500'>
						{t('title')}
					</p>
					<p className='py-6'>{t('subTitle')}</p>
				</div>
				<div className='flex justify-center items-center'>
					<form
						action='https://getform.io/f/94e2f679-f894-41da-9256-3d717e8779b5'
						method='POST'
						className='flex flex-col w-full md:w1/2'
					>
						<input
							type='text'
							name='name'
							placeholder='Enter your name'
							className='p-2 bg-transparent border-2 rounded-md text-white 
              focus:outline-none'
						/>
						<input
							type='email'
							name='email'
							placeholder='Enter your email'
							className='my-4 p-2 bg-transparent border-2 rounded-md text-white 
              focus:outline-none'
						/>
						<textarea
							name='message'
							rows='10'
							placeholder='Enter your message'
							className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none'
						></textarea>

						<button
							disabled
							className='text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-4 py-3 my-8
              mx-auto flex items-center rounded-md hover:scale-110 duration-300'
						>
							lets talk
						</button>
					</form>
				</div>
			</div>
		</section>
	);
};

export default Conact;
